import React from 'react';
import './SleepingBear.css';

// The sleeping bear from the reference drawing, asleep on the
// internships divider. The PNG is white-line-on-black; mix-blend-mode
// screen makes the black invisible against the page so only the drawn
// lines show. He breathes gently, with Zzz floating above his head.
const SleepingBear = () => (
  <div className="sleeping-bear" aria-hidden="true">
    <img className="bear-img" src="/images/sleeping-bear.png" alt="" />
    <span className="bear-eye" />
    <span className="bear-z bear-z1">z</span>
    <span className="bear-z bear-z2">z</span>
    <span className="bear-z bear-z3">Z</span>
  </div>
);

export default SleepingBear;
